import React from 'react';
import styled from 'styled-components';
import { SlideContainer } from './container';
import { SlideContent } from './content';
import { Text } from './text';
import { Highlight } from './highlight';
import { SlideProps } from '../Recap';
import RecapSlide from '../RecapSlide';
import { Marquee } from './marquee';
import { asset } from '../../../utils/misc';

const MegaphoneImage = styled.img`
  position: absolute;
  top: -20px;
  right: -30px;
  width: 80px;
`;

const primaryColor = '#c0324a';
const secondaryColor = '#ffd8a1';

export const Slide4 = ({ current = false, scale, data, soundEnabled = false }: SlideProps) => {
    const musicUrl = asset('/dist/audio/recap-music-04.mp3');
    const soundUrl = asset('/dist/audio/pop-02.mp3?1');
    const sizeFactor = 1.4;

    return (
        <RecapSlide animations={[
            ['line-1'],
            ['line-2'],
            ['line-3', 'megaphone-image'],
            ['line-4'],
        ]} focus={current} soundEnabled={soundEnabled} musicUrl={musicUrl} soundUrl={soundUrl} playSoundOnce={true}>
            <SlideContainer>
                <SlideContent bg={secondaryColor} scale={scale}>
                    <Text className="overflow-h line-1" fontFamily='fifties-cond-med' fontSize={`${40 * sizeFactor}px`} color={primaryColor}>
                        <span className="anim anim-fade-in">Este</span>
                    </Text>

                    <Text className="overflow-h line-2" fontFamily='fifties-cond-med' fontSize={`${63 * sizeFactor}px`} color={primaryColor}>
                        <span className="anim anim-slide-from-top">spoiler</span>
                    </Text>

                    <div style={{ position: 'relative' }}>
                        <Highlight className="overflow-h anim anim-fade-in line-3" bg={primaryColor} color={secondaryColor} fontFamily='fifties-cond-med' fontSize={`${42 * sizeFactor}px`} style={{
                            display: 'block',
                            padding: `${3 * sizeFactor}px ${25 * sizeFactor}px ${3 * sizeFactor}px ${14 * sizeFactor}px`,
                            marginBottom: `${10 * sizeFactor}px`,
                        }}>
                            <span className="anim anim-slide-from-left anim-fade-in" style={{
                                display: 'block',
                                marginBottom: -5 * sizeFactor + 'px',
                            }}>Te va a</span>
                            <span className="anim anim-slide-from-left anim-fade-in">encantar</span>
                        </Highlight>

                        <MegaphoneImage src={asset('/dist/images/year-recap/megaphone.png')} className='megaphone-image anim anim-scale-in anim-fade-in'/>
                    </div>

                    <Text className="overflow-h line-4" fontFamily='fifties-cond-med' color={primaryColor} fontSize={`${46 * sizeFactor}px`}>
                        <span className="anim anim-slide-from-above">Estrenos</span>
                        {' '}
                        <span className="anim anim-slide-from-above">2026</span>
                    </Text>

                    <div style={{ opacity: current ? 1: 0}}>
                        <Marquee images={[
                            '01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19'
                        ]} className="mb-2" />
                    </div>
                </SlideContent>
            </SlideContainer>
        </RecapSlide>
    );
};